import qs from "query-string";

export function post(url = ``, data, headers) {
  return fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "include",
    headers: headers || {
      "Content-Type": "application/json; charset=utf-8"
    },
    body: data instanceof FormData ? data : JSON.stringify(data || {})
  }).then(handleFetchResponse);
}

export function get(url = ``, params, headers) {
  return fetch(url + (url.indexOf("?") === -1 ? "?" : "&") + qs.stringify(params), {
    mode: "cors",
    cache: "no-cache",
    credentials: "include",
    headers: headers || {
      "Content-Type": "application/json; charset=utf-8"
    }
  }).then(handleFetchResponse);
}

function handleFetchResponse(r) {
  if (r.ok) {
    return r.json();
  } else {
    return r.json().then(body => {
      throw Object.assign(
        { status: r.status, statusText: r.statusTex },
        body || {}
      );
    });
  }
}
